import { Route } from '@angular/router';
import { authGuard, bookEnabledGuard, commercialManageVehiclesEnabledGuard, noAuthGuard } from './guards/auth.guard';
import { BaseLayoutComponent } from './components/layout/base-layout/base-layout.component';
import { ApplicationOrigin } from '@vtnz/api';

export const appRoutes: Route[] = [
  {
    path: 'login',
    title: 'Login',
    canActivate: [noAuthGuard],
    data: { hideAccountDropdown: true, origin: ApplicationOrigin.Customer },
    loadComponent: () => import('@vtnz/ui').then((m) => m.LoginPageComponent),
  },
  {
    path: 'login-validation',
    title: 'Validate Login',
    canActivate: [noAuthGuard],
    data: { hideAccountDropdown: true },
    loadComponent: () => import('@vtnz/ui').then((m) => m.LoginValidationPageComponent),
  },
  {
    path: 'logout',
    title: 'Logout',
    data: { hideAccountDropdown: true },
    loadComponent: () => import('@vtnz/ui').then((m) => m.LogoutPageComponent),
  },
  {
    path: 'create-account',
    title: 'Create Account',
    canActivate: [noAuthGuard],
    loadComponent: () =>
      import('./pages/create-account-page/create-account-page.component').then(
        (m) => m.CreateAccountPageComponent
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    component: BaseLayoutComponent,
    data: {
      applicationTitle: 'Customer Portal',
    },
    children: [
      {
        path: '',
        title: 'Home',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        title: 'Home',
        loadComponent: () =>
          import('./pages/home/home-page.component').then((m) => m.HomePageComponent),
      },
      {
        path: 'book-inspection',
        title: 'Book Inspection',
        canActivate: [bookEnabledGuard],
        loadComponent: () =>
          import('./pages/book-inspection/book-inspection-page.component').then(
            (m) => m.BookInspectionPageComponent
          ),
      },
      {
        path: 'billing',
        title: 'Billing',
        loadComponent: () =>
          import('./pages/billing-page/billing-page.component').then((m) => m.BillingPageComponent),
      },
      {
        path: 'manage-vehicles',
        title: 'Manage My Vehicles',
        canActivate: [commercialManageVehiclesEnabledGuard],
        loadComponent: () =>
          import('./pages/manage-my-vehicles-page/manage-my-vehicles-page.component').then(
            (m) => m.ManageMyVehiclesPageComponent
          ),
      },
      {
        path: 'document/:id',
        title: 'Document View',
        loadComponent: () =>
          import('./pages/document-view-page/document-view-page.component').then(
            (m) => m.DocumentViewPageComponent
          ),
      },
      {
        path: 'reports',
        title: 'Reports',
        loadComponent: () =>
          import('./pages/reports-page/reports-page.component').then((m) => m.ReportsPageComponent),
      },
      {
        path: 'my-profile',
        title: 'My Profile',
        loadComponent: () =>
          import('./pages/my-profile-page/my-profile-page.component').then(
            (m) => m.MyProfilePageComponent
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
